// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SectionHeader {
  background-color: #FAFAFA;
  border-radius: 6px;
  padding: 0.5em;
  margin-left: -0.5em;
  margin-right: -0.5em;
  margin-bottom: 1.5em;
}
/*# sourceMappingURL=SectionHeader.css.map */`, "",{"version":3,"sources":["webpack://./SectionHeader.less","webpack://./wp_components/core/SectionHeader/SectionHeader.less"],"names":[],"mappings":"AAEA;EACI,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;ACDJ;AACA,4CAA4C","sourcesContent":["@import url('../../../less/variables.less');\n\n.SectionHeader {\n    background-color: @secondary-25;\n    border-radius: @radius-sm;\n    padding: 0.5em;\n    margin-left: -0.5em;\n    margin-right: -0.5em;\n    margin-bottom: @element-margin;\n}",".SectionHeader {\n  background-color: #FAFAFA;\n  border-radius: 6px;\n  padding: 0.5em;\n  margin-left: -0.5em;\n  margin-right: -0.5em;\n  margin-bottom: 1.5em;\n}\n/*# sourceMappingURL=SectionHeader.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
